function getString(key: string, fallback = ""): string {
  return (import.meta.env[key] as string | undefined) ?? fallback
}

export const env = {
  VITE_APP_NAME: getString("VITE_APP_NAME", "MyApp"),

  // Application backend (lpr4-astrology-backend): user profile + Today data.
  VITE_API_URL: getString("VITE_API_URL", "https://api.astrology.clinic"),

  // Firebase
  VITE_FIREBASE_API_KEY: getString("VITE_FIREBASE_API_KEY"),
  VITE_FIREBASE_AUTH_DOMAIN: getString("VITE_FIREBASE_AUTH_DOMAIN"),
  VITE_FIREBASE_APP_ID: getString("VITE_FIREBASE_APP_ID"),

  // Payments
  VITE_PAYMENT_API_URL: getString("VITE_PAYMENT_API_URL"),
  VITE_PAYPAL_CLIENT_ID: getString("VITE_PAYPAL_CLIENT_ID"),
  /** Provider plan id charged for the fallback plan when no config/URL plan is present. */
  VITE_DEFAULT_PLAN_ID: getString("VITE_DEFAULT_PLAN_ID"),

  // Products / Subscriptions
  VITE_PLANS_API_URL: getString("VITE_PLANS_API_URL"),
  VITE_SUBSCRIPTIONS_API_URL: getString("VITE_SUBSCRIPTIONS_API_URL"),
  VITE_SUBSCRIPTION_BUNDLE: getString("VITE_SUBSCRIPTION_BUNDLE"),

  // Geo (defaults to Cloudflare trace — plain-text key=value endpoint)
  VITE_GEO_API_URL: getString("VITE_GEO_API_URL", "https://www.cloudflare.com/cdn-cgi/trace"),

  // Config-driven funnel: GET {url}/{configId} -> { url?, params }
  VITE_CONFIG_API_URL: getString("VITE_CONFIG_API_URL"),
  VITE_CONFIG_ID_PREFIX: getString("VITE_CONFIG_ID_PREFIX", "cfg_"),

  // Analytics
  VITE_GA_MEASUREMENT_ID: getString("VITE_GA_MEASUREMENT_ID"),
  VITE_FB_PIXEL_ID: getString("VITE_FB_PIXEL_ID"),

  // Monitoring
  VITE_SENTRY_DSN: getString("VITE_SENTRY_DSN"),

  // Advisors live-chat socket (ported from lpr-web ChatProvider).
  VITE_ADVISORS_SOCKET_URL: getString(
    "VITE_ADVISORS_SOCKET_URL",
    "https://lpr4-astrology.uc.r.appspot.com/",
  ),
  // Shared HS256 secret the advisors-core backend validates the socket JWT against.
  // MUST be provided via env — never hardcode a credential in source.
  VITE_ADVISORS_SOCKET_SECRET: getString("VITE_ADVISORS_SOCKET_SECRET"),
  // Domain identifier embedded in the socket JWT (was `btoa(recurlyBaseURL)` in lpr-web).
  VITE_ADVISORS_RECURLY_BASE_URL: getString(
    "VITE_ADVISORS_RECURLY_BASE_URL",
    getString("VITE_SUBSCRIPTIONS_API_URL"),
  ),

  /** Love Match (Relationship Truths) report PDF hosted on CDN/storage. */
  VITE_LOVE_MATCH_PDF_URL: getString("VITE_LOVE_MATCH_PDF_URL"),

  // Trustpilot / feedback (review modal)
  VITE_REVIEW_URL: getString("VITE_REVIEW_URL"),
  VITE_FEEDBACK_API_URL: getString("VITE_FEEDBACK_API_URL"),
  VITE_FEEDBACK_SECRET_KEY: getString("VITE_FEEDBACK_SECRET_KEY"),

  // DEV ONLY (see src/config/dev-bypass.ts): open the webapp without login.
  // Only honored under `vite dev`; ignored in production builds.
  VITE_DEV_BYPASS_AUTH: getString("VITE_DEV_BYPASS_AUTH"),

  // DEV ONLY (see src/config/dev-bypass.ts): mock the report purchase (skip the
  // real charge) to test the post-purchase UX locally. Ignored in prod builds.
  VITE_DEV_MOCK_PURCHASE: getString("VITE_DEV_MOCK_PURCHASE"),
}
